import T from "@redwit-commons/utils/typecheck";

export enum ReviewStatus {
  PENDING = "Review::PENDING",
  IN_PROGRESS = "Review::IN_PROGRESS",
  APPROVED = "Review::APPROVED",
  REJECTED = "Review::REJECTED",
  WITHDRAWN = "Review::WITHDRAWN",
}

export const ReviewStatusSchema = T.string().withEnum([
  ReviewStatus.PENDING,
  ReviewStatus.APPROVED,
  ReviewStatus.REJECTED,
  ReviewStatus.WITHDRAWN,
  ReviewStatus.IN_PROGRESS,
]);

export enum ReviewFileTransformStatus {
  PENDING = "ReviewFile::PENDING",
  SUCCESS = "ReviewFile::SUCCESS",
  FAILED = "ReviewFile::FAILED",
}

export const ReviewFileTransformStatusSchema = T.string().withEnum([
  ReviewFileTransformStatus.PENDING,
  ReviewFileTransformStatus.SUCCESS,
  ReviewFileTransformStatus.FAILED,
]);

export enum ReviewResponseStatus {
  PENDING = "ReviewResponse::PENDING",
  APPROVED = "ReviewResponse::APPROVED",
  REJECTED = "ReviewResponse::REJECTED",
}

export const ReviewResponseStatusSchema = T.string().withEnum([
  ReviewResponseStatus.PENDING,
  ReviewResponseStatus.APPROVED,
  ReviewResponseStatus.REJECTED,
]);

export enum ReviewLogType {
  REQUESTED = "ReviewLog::REQUESTED",
  STARTED = "ReviewLog::STARTED",
  APPROVED = "ReviewLog::APPROVED",
  REJECTED = "ReviewLog::REJECTED",
  WITHDRAWN = "ReviewLog::WITHDRAWN",
  FILE_REPLACED = "ReviewLog::FILE_REPLACED",
  REVIEWER_REPLACED = "ReviewLog::REVIEWER_REPLACED",
  REVIEWER_APPROVED = "ReviewLog::REVIEWER_APPROVED",
  REVIEWER_REJECTED = "ReviewLog::REVIEWER_REJECTED",
}

export const ReviewLogTypeSchema = T.string().withEnum([
  ReviewLogType.REQUESTED,
  ReviewLogType.STARTED,
  ReviewLogType.APPROVED,
  ReviewLogType.REJECTED,
  ReviewLogType.WITHDRAWN,
  ReviewLogType.FILE_REPLACED,
  ReviewLogType.REVIEWER_REPLACED,
  ReviewLogType.REVIEWER_APPROVED,
  ReviewLogType.REVIEWER_REJECTED,
]);
